import z from 'zod';
import { createIdSchema } from '../../lib/util/id.js';
import { createStrictSchema } from '../../lib/util/zod-helpers.js';
// ===== ID SCHEMAS =====
const UserIdSchema = createIdSchema('user');
const UserTableSelectSchema = createStrictSchema()({
    id: UserIdSchema,
    // @todo: make a dedicated password schema
    password: z.string(),
    email: z.email(),
    name: z.string().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
/* const UserWorkoutPlanSubscriptionTableSelectSchema = createSelectSchema(
    userWorkoutPlanSubscriptionTable,
    {
        userId: UserTableSelectSchema.shape.id,
        workoutPlanId: createIdSchema('workoutPlan'),
    },
);
type UserWorkoutPlanSubscriptionTableSelect = z.output<
    typeof UserWorkoutPlanSubscriptionTableSelectSchema
>; */
// ===== PUBLIC SCHEMAS (to be used by other layers) =====
const UserInfoSchema = UserTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
    password: true,
}).extend({
    updatedAt: z.string(), // ISO date string for API
});
const UserInfoIdSchema = UserIdSchema;
export { UserInfoIdSchema, UserInfoSchema, UserTableSelectSchema };
//# sourceMappingURL=user.types.js.map